import axios from 'axios';
axios.defaults.baseURL = 'https://reg1535.ru:8443';
// axios.defaults.baseURL = 'http://localhost:3005';
export default axios;